var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResultEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211,
    height: 211,
    viewBox: "0 0 211 211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(-597 -228)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 105.5,
    cy: 105.5,
    r: 105.5,
    transform: "translate(597 228)",
    fill: "#655a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-share_rounded",
    d: "M49.645,4.5A4.255,4.255,0,0,0,46.7,5.747L29.681,22.763A4.254,4.254,0,1,0,35.7,28.779l9.748-9.75L45.4,75.4a4.254,4.254,0,1,0,8.509.011l.049-56.39,9.76,9.76a4.254,4.254,0,1,0,6.016-6.016L52.713,5.747A4.255,4.255,0,0,0,49.645,4.5ZM25.6,39.952A15.664,15.664,0,0,0,10,55.55v45.378a15.664,15.664,0,0,0,15.6,15.6H73.812a15.664,15.664,0,0,0,15.6-15.6V55.55a15.664,15.664,0,0,0-15.6-15.6H68.14a4.254,4.254,0,1,0,0,8.509h5.672a7.028,7.028,0,0,1,7.09,7.09v45.378a7.028,7.028,0,0,1-7.09,7.09H25.6a7.028,7.028,0,0,1-7.09-7.09V55.55a7.028,7.028,0,0,1,7.09-7.09h5.672a4.254,4.254,0,1,0,0-8.509Z",
    transform: "translate(652.791 272.982)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultEmailIcon);
export default __webpack_public_path__ + "static/media/ResultEmailIcon.1cd491575c1b7d0b8064b13f0abf1154.svg";
export { ForwardRef as ReactComponent };